<template>
  <div style="display: flex; align-items: center">
    <svg
      v-if="name === 'addMonitorIcon'"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.1961 6.51313C11.2526 6.21542 11.2822 5.90816 11.2822 5.59399C11.2822 2.89068 9.09076 0.699219 6.38745 0.699219C3.68414 0.699219 1.49268 2.89068 1.49268 5.59399C1.49268 8.2973 3.68414 10.4888 6.38745 10.4888C6.78151 10.4888 7.16468 10.4422 7.53178 10.3543"
        stroke="#05ABFA"
        stroke-width="1.2"
        stroke-linecap="round"
      />
      <path
        d="M6.3645 7.76416C7.51451 7.76416 8.44678 6.83189 8.44678 5.68188C8.44678 4.53188 7.51451 3.59961 6.3645 3.59961C5.21449 3.59961 4.28223 4.53188 4.28223 5.68188C4.28223 6.83189 5.21449 7.76416 6.3645 7.76416Z"
        stroke="#05ABFA"
        stroke-width="1.22387"
      />
      <path
        d="M3.82568 12.5H8.49235"
        stroke="#05ABFA"
        stroke-width="1.2"
        stroke-linecap="round"
      />
      <path d="M6.15918 10.5078V12.2578" stroke="#05ABFA" stroke-width="1.2" />
      <path
        d="M9.28418 10.9648H12.7842"
        stroke="#05ABFA"
        stroke-width="1.2"
        stroke-linecap="round"
      />
      <path
        d="M11.0342 9.21484V12.7148"
        stroke="#05ABFA"
        stroke-width="1.2"
        stroke-linecap="round"
      />
    </svg>
    <svg
      v-if="name === 'addVerifyIcon'"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.5625 11.25H13.0625"
        stroke="#05ABFA"
        stroke-width="1.2"
        stroke-linecap="round"
      />
      <path
        d="M11.3125 9.5V13"
        stroke="#05ABFA"
        stroke-width="1.2"
        stroke-linecap="round"
      />
      <path
        d="M11.5208 6.7513V1.2513C11.5208 0.929136 11.2597 0.667969 10.9375 0.667969H2.77083C2.44867 0.667969 2.1875 0.929136 2.1875 1.2513V11.7513C2.1875 12.0735 2.44867 12.3346 2.77083 12.3346H7.5625"
        stroke="#05ABFA"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.521 8.25H8.60433"
        stroke="#05ABFA"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.521 10H6.56266"
        stroke="#05ABFA"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.60433 3H4.521V5.91667H8.60433V3Z"
        stroke="#05ABFA"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <!-- ？ -->
    <svg
      v-if="name === 'questioninfo'"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 0C7.65669 0 9.157 0.672627 10.2422 1.75781C11.3274 2.84301 12 4.34331 12 6C12 7.65669 11.3274 9.157 10.2422 10.2422C9.157 11.3274 7.65669 12 6 12C4.34331 12 2.84301 11.3274 1.75781 10.2422C0.672627 9.157 0 7.65669 0 6C0 4.34331 0.672631 2.84301 1.75781 1.75781C2.84301 0.67263 4.34331 0 6 0ZM6 8.35352C5.62359 8.35361 5.31846 8.65874 5.31836 9.03516C5.31836 9.41165 5.62353 9.7167 6 9.7168C6.37655 9.7168 6.68164 9.41171 6.68164 9.03516C6.68154 8.65868 6.37649 8.35352 6 8.35352ZM6 2.35352C4.79516 2.35361 3.81846 3.33031 3.81836 4.53516H4.90918C4.90928 3.93281 5.39765 3.44443 6 3.44434C6.60243 3.44434 7.09072 3.93275 7.09082 4.53516C7.09082 5.13765 6.60249 5.62598 6 5.62598C5.69884 5.62607 5.45508 5.87069 5.45508 6.17188V7.2627H6.5459V6.64844C7.48681 6.40615 8.18164 5.55171 8.18164 4.53516C8.18154 3.33026 7.20492 2.35352 6 2.35352Z"
        fill="#BAC0CA"
      />
    </svg>
    <svg
      v-if="name === 'tipIcon'"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99967 14.6693C9.84061 14.6693 11.5073 13.9231 12.7137 12.7166C13.9201 11.5102 14.6663 9.84354 14.6663 8.0026C14.6663 6.16167 13.9201 4.495 12.7137 3.28856C11.5073 2.08213 9.84061 1.33594 7.99967 1.33594C6.15874 1.33594 4.49207 2.08213 3.28563 3.28856C2.0792 4.495 1.33301 6.16167 1.33301 8.0026C1.33301 9.84354 2.0792 11.5102 3.28563 12.7166C4.49207 13.9231 6.15874 14.6693 7.99967 14.6693Z"
        stroke="#EBA43F"
        stroke-width="1.37143"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.00033 12.3307C8.46056 12.3307 8.83366 11.9576 8.83366 11.4974C8.83366 11.0372 8.46056 10.6641 8.00033 10.6641C7.54009 10.6641 7.16699 11.0372 7.16699 11.4974C7.16699 11.9576 7.54009 12.3307 8.00033 12.3307Z"
        fill="#EBA43F"
      />
      <path
        d="M8 4V9.33333"
        stroke="#EBA43F"
        stroke-width="1.37143"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <!-- 复制按钮 -->
    <svg
      v-if="name === 'copyIcon'"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.33301 4.1437V2.604C4.33301 2.08624 4.75274 1.6665 5.27051 1.6665H13.3955C13.9133 1.6665 14.333 2.08624 14.333 2.604V10.729C14.333 11.2468 13.9133 11.6665 13.3955 11.6665H11.8384"
        stroke="white"
        stroke-width="1.2"
        stroke-linecap="square"
        stroke-linejoin="round"
      />
      <path
        d="M10.7295 4.3335H2.60449C2.08673 4.3335 1.66699 4.75323 1.66699 5.271V13.396C1.66699 13.9138 2.08673 14.3335 2.60449 14.3335H10.7295C11.2473 14.3335 11.667 13.9138 11.667 13.396V5.271C11.667 4.75323 11.2473 4.3335 10.7295 4.3335Z"
        stroke="white"
        stroke-width="1.2"
        stroke-linejoin="round"
      />
    </svg>
    <!-- 搜索 -->
    <svg
      v-if="name === 'searchNodeIcon'"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.4918 7.53236C12.4918 10.5765 9.99097 13.0647 6.88068 13.0647C3.77039 13.0647 1.26953 10.5765 1.26953 7.53236C1.26953 4.48819 3.77039 2 6.88068 2C9.99097 2 12.4918 4.48819 12.4918 7.53236Z"
        stroke="#BAC0CA"
        stroke-width="2"
      />
      <path
        d="M11.1582 11.7593L14.2693 14.8333"
        stroke="#BAC0CA"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- x号 有背景色 -->
    <svg
      v-if="name === 'clearData'"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.875 9C16.875 4.65076 13.3492 1.125 9 1.125C4.65076 1.125 1.125 4.65076 1.125 9C1.125 13.3492 4.65076 16.875 9 16.875C13.3492 16.875 16.875 13.3492 16.875 9ZM6.37977 5.56598L9.00001 8.2021L11.6203 5.56598L12.4181 6.35907L9.79312 9L12.4181 11.6409L11.6202 12.434L9.00001 9.79791L6.37978 12.434L5.58189 11.6409L8.20691 9L5.58188 6.35907L6.37977 5.56598Z"
        fill="#A2A9B6"
      />
    </svg>
    <svg
      v-if="name === 'smallclearData'"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_42528_33865)">
        <path
          d="M13.125 7C13.125 3.61726 10.3827 0.875001 7 0.875C3.61726 0.874998 0.875001 3.61725 0.875 7C0.874998 10.3827 3.61725 13.125 7 13.125C10.3827 13.125 13.125 10.3827 13.125 7ZM4.96204 4.3291L7.00001 6.37941L9.03798 4.3291L9.65856 4.94594L7.61687 7L9.65855 9.05405L9.03797 9.6709L7.00001 7.6206L4.96205 9.6709L4.34147 9.05405L6.38315 7L4.34146 4.94594L4.96204 4.3291Z"
          fill="#A2A9B6"
        />
      </g>
      <defs>
        <clipPath id="clip0_42528_33865">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
    <!-- x号没有背景色 -->
    <svg
      v-if="name === 'cleardata'"
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M0.777344 0.777344L13.2218 13.2218"
        stroke="#A2A9B6"
        stroke-width="1.55556"
      />
      <path
        d="M13.2217 0.777344L0.777235 13.2218"
        stroke="#A2A9B6"
        stroke-width="1.55556"
      />
    </svg>
    <!-- +号 -->
    <svg
      v-if="name === 'addcanvas'"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_42068_36282)">
        <path
          d="M7.9987 14.6673C11.6806 14.6673 14.6654 11.6826 14.6654 8.00065C14.6654 4.31875 11.6806 1.33398 7.9987 1.33398C4.3168 1.33398 1.33203 4.31875 1.33203 8.00065C1.33203 11.6826 4.3168 14.6673 7.9987 14.6673Z"
          stroke="#0D0E0F"
          stroke-width="1.2"
          stroke-linejoin="round"
        />
        <path
          d="M8 5.33398V10.6673"
          stroke="#0D0E0F"
          stroke-width="1.2"
          stroke-linecap="square"
          stroke-linejoin="round"
        />
        <path
          d="M5.33203 8H10.6654"
          stroke="#0D0E0F"
          stroke-width="1.2"
          stroke-linecap="square"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_42068_36282">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
    <!-- 返回箭头图标 -->
    <svg
      v-if="name === 'back-arrow'"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.89941 12H20.8994"
        stroke="#0D0E0F"
        stroke-width="1.5"
        stroke-linejoin="round"
      />
      <path
        d="M8.8994 18L2.89941 12L8.8994 6"
        stroke="#0D0E0F"
        stroke-width="1.5"
        stroke-linejoin="round"
      />
    </svg>
    <!-- 下载图标 -->
    <svg
      v-if="name === 'downIcon'"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.94695 0.375317V12.1696M9.94695 12.1696L5.77116 7.99382M9.94695 12.1696L14.1227 7.99382"
        stroke="#0D0E0F"
        stroke-width="1.5"
      />
      <path
        d="M1.5 11V16.3125C1.5 16.8993 1.9757 17.375 2.5625 17.375H17.4375C18.0243 17.375 18.5 16.8993 18.5 16.3125V11"
        stroke="#0D0E0F"
        stroke-width="1.5"
      />
    </svg>
    <!-- BTC图标 -->
    <svg
      v-if="name === 'btc'"
      width="18"
      height="18"
      viewBox="0 0 62 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_42051_22213)">
        <path
          d="M62 31C62 48.1203 48.1211 62 31 62C13.8789 62 0 48.1203 0 31C0 13.8797 13.8789 0 31 0C48.1211 0 62 13.8789 62 31ZM44.2969 26.5836C44.9141 22.4586 41.7727 20.2414 37.4781 18.7625L38.8711 13.1742L35.4688 12.3266L34.1125 17.7672C33.218 17.5445 32.3 17.3344 31.3875 17.1258L32.7531 11.65L29.3516 10.8023L27.957 16.3883C27.2172 16.2188 26.4898 16.0523 25.7852 15.8773L25.7891 15.8602L21.0977 14.6883L20.193 18.3203C20.193 18.3203 22.7164 18.8992 22.6633 18.9352C24.0414 19.2789 24.2898 20.1898 24.2484 20.9133L22.6609 27.2789C22.7814 27.3082 22.8996 27.3458 23.0148 27.3914L22.6555 27.3023L20.4312 36.2203C20.2625 36.6391 19.8352 37.2672 18.8687 37.0289C18.9031 37.0781 16.3961 36.4117 16.3961 36.4117L14.7109 40.3047L19.1406 41.4062C19.9641 41.6125 20.7711 41.8281 21.5625 42.0312L20.1562 47.6836L23.5539 48.5312L24.9484 42.9398C25.8495 43.1836 26.7531 43.418 27.6594 43.643L26.2695 49.2078L29.6711 50.0555L31.0773 44.4148C36.8781 45.5125 41.2398 45.0695 43.0758 39.8242C44.5555 35.6 43.0023 33.1641 39.9508 31.575C42.1734 31.0625 43.8477 29.6008 44.2945 26.5812L44.2969 26.5836ZM36.5219 37.4813C35.4703 41.7047 28.3578 39.4211 26.0531 38.8492L27.9211 31.3617C30.2266 31.9367 37.6211 33.0766 36.5227 37.4813H36.5219ZM37.5734 26.5227C36.6141 30.3648 30.6945 28.4125 28.7742 27.9344L30.4688 21.1437C32.3891 21.6219 38.5734 22.5148 37.5742 26.5227H37.5734Z"
          fill="#E58F42"
        />
      </g>
      <defs>
        <clipPath id="clip0_42051_22213">
          <rect width="62" height="62" fill="white" />
        </clipPath>
      </defs>
    </svg>
    <!-- 分享画布 -->
    <svg
      v-if="name === 'sharecanvas'"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.4375 10C17.4375 14.1076 14.1076 17.4375 10 17.4375C5.89238 17.4375 2.5625 14.1076 2.5625 10C2.5625 5.89238 5.89238 2.5625 10 2.5625M10 10L17.4375 2.5625M17.4375 2.5625H12.975M17.4375 2.5625V7.025"
        stroke="#05ABFA"
        stroke-width="1.5"
      />
    </svg>
    <svg
      v-if="name === 'newsharecanvas'"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.9508 8.00078C13.9508 11.2869 11.2869 13.9508 8.00078 13.9508C4.71469 13.9508 2.05078 11.2869 2.05078 8.00078C2.05078 4.71469 4.71469 2.05078 8.00078 2.05078M8.00078 8.00078L13.9508 2.05078M13.9508 2.05078H10.3808M13.9508 2.05078V5.62078"
        :stroke="iconColor || '#05ABFA'"
        stroke-width="1.4"
      />
    </svg>

    <!-- 信息提示图标 -->
    <svg
      v-if="name === 'info'"
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5 0C3.61942 0 2.3688 0.560143 1.46447 1.46446C0.560149 2.3688 0 3.61942 0 5C0 6.38058 0.560146 7.6312 1.46447 8.53553C2.3688 9.43985 3.61942 10 5 10C6.38058 10 7.6312 9.43985 8.53553 8.53553C9.43985 7.6312 10 6.38058 10 5C10 3.61942 9.43985 2.3688 8.53553 1.46446C7.6312 0.560143 6.38058 0 5 0ZM5.00015 1.96025C3.996 1.96025 3.18197 2.77428 3.18197 3.77843H4.09106C4.09106 3.27635 4.49807 2.86934 5.00015 2.86934C5.50222 2.86934 5.90924 3.27635 5.90924 3.77843C5.90924 4.2805 5.50222 4.68752 5.00015 4.68752C4.74911 4.68752 4.5456 4.89103 4.5456 5.14206V6.05115H5.45469V5.53933C6.23889 5.33749 6.81833 4.62563 6.81833 3.77843C6.81833 2.77428 6.0043 1.96025 5.00015 1.96025ZM5.56833 7.52843C5.56833 7.84222 5.31394 8.09661 5.00015 8.09661C4.68635 8.09661 4.43197 7.84222 4.43197 7.52843C4.43197 7.21463 4.68635 6.96025 5.00015 6.96025C5.31394 6.96025 5.56833 7.21463 5.56833 7.52843Z"
        fill="#3B82F6"
        fill-opacity="0.5"
      />
    </svg>

    <!-- 地址省略图标 -->
    <svg
      v-if="name === 'address-collapse'"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0.400391 3H14.8004" stroke="black" stroke-width="1.2" />
      <path d="M0.400391 13.3999H9.20039" stroke="black" stroke-width="1.2" />
      <rect x="0.400391" y="7.2002" width="1.6" height="1.6" fill="#0D0E0F" />
      <rect x="3.59961" y="7.2002" width="1.6" height="1.6" fill="#0D0E0F" />
      <rect x="6.7998" y="7.2002" width="1.6" height="1.6" fill="#0D0E0F" />
      <rect x="10" y="7.2002" width="1.6" height="1.6" fill="#0D0E0F" />
      <path d="M11.2002 10L15.2002 13.6" stroke="black" stroke-width="1.2" />
      <path d="M15.2002 10L11.2002 13.6" stroke="black" stroke-width="1.2" />
    </svg>

    <!-- 地址展开图标 -->
    <svg
      v-if="name === 'address-expand'"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0.400391 3H14.8004" stroke="black" stroke-width="1.2" />
      <path d="M0.400391 13.3999H9.20039" stroke="black" stroke-width="1.2" />
      <rect x="0.400391" y="7.2002" width="1.6" height="1.6" fill="#0D0E0F" />
      <rect x="3.59961" y="7.2002" width="1.6" height="1.6" fill="#0D0E0F" />
      <rect x="6.7998" y="7.2002" width="1.6" height="1.6" fill="#0D0E0F" />
      <rect x="10" y="7.2002" width="1.6" height="1.6" fill="#0D0E0F" />
      <path d="M10 11L11.5 13L15 10" stroke="black" stroke-width="1.2" />
    </svg>

    <!-- 保存图标 -->
    <svg
      v-if="name === 'savaicon'"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.25 2.5H3.75C3.05965 2.5 2.5 3.05965 2.5 3.75V16.25C2.5 16.9404 3.05965 17.5 3.75 17.5H16.25C16.9404 17.5 17.5 16.9404 17.5 16.25V3.75C17.5 3.05965 16.9404 2.5 16.25 2.5Z"
        stroke="white"
        stroke-width="1.5"
      />
      <path
        d="M13.3327 2.5H6.66602V6.66667H13.3327V2.5Z"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.08398 15H12.9173"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="name === 'newsavaicon'"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 2H3C2.44772 2 2 2.44772 2 3V13C2 13.5523 2.44772 14 3 14H13C13.5523 14 14 13.5523 14 13V3C14 2.44772 13.5523 2 13 2Z"
        stroke="white"
        stroke-width="1.4"
      />
      <path
        d="M10.6654 2H5.33203V5.33333H10.6654V2Z"
        stroke="white"
        stroke-width="1.4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.66797 12H10.3346"
        stroke="white"
        stroke-width="1.4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <!-- 扩展方向 -->
    <svg
      v-if="name === 'inflow'"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3614 5.94183C12.9113 5.9431 12.4725 6.08356 12.1054 6.34397C11.7382 6.60438 11.4605 6.97198 11.3105 7.39638H9.71049L7.18685 3.03274H3.92867L1.91413 1.10547L0.888672 2.16001L2.49594 3.68729L0.888672 5.34547L1.92867 6.36365L3.79776 4.48729H6.34322L8.43776 8.12365L6.34322 11.76H3.89958L1.91413 9.83274L0.888672 10.9091L2.49594 12.4437L0.888672 14.1018L1.92867 15.1127L3.79776 13.2146H7.17958L9.70322 8.85092H11.3032C11.4365 9.228 11.6709 9.56117 11.9808 9.81404C12.2907 10.0669 12.6641 10.2297 13.0602 10.2847C13.4564 10.3397 13.86 10.2848 14.227 10.1259C14.5941 9.96701 14.9104 9.71029 15.1414 9.38379C15.3724 9.05729 15.5092 8.67358 15.5368 8.27459C15.5645 7.8756 15.482 7.47668 15.2983 7.12143C15.1145 6.76617 14.8367 6.46825 14.4951 6.26022C14.1535 6.05218 13.7613 5.94204 13.3614 5.94183ZM13.3614 8.85092C13.2176 8.85092 13.0769 8.80827 12.9573 8.72835C12.8377 8.64844 12.7445 8.53486 12.6895 8.40197C12.6344 8.26907 12.62 8.12284 12.6481 7.98177C12.6762 7.84069 12.7454 7.7111 12.8471 7.60939C12.9489 7.50768 13.0784 7.43841 13.2195 7.41035C13.3606 7.38229 13.5068 7.39669 13.6397 7.45174C13.7726 7.50678 13.8862 7.6 13.9661 7.7196C14.046 7.8392 14.0887 7.97981 14.0887 8.12365C14.0887 8.31653 14.012 8.50152 13.8757 8.63791C13.7393 8.7743 13.5543 8.85092 13.3614 8.85092Z"
        :fill="isSelected ? '#FFFFFF' : '#0D0E0F'"
      />
    </svg>
    <svg
      v-if="name === 'outflow'"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.1824 11.5803H9.38972L7.28791 7.94389L9.38972 4.30753H12.1824V5.76207L15.8188 3.58026L12.1824 1.39844V2.85298H8.54609L6.00063 7.21662H4.42245C4.25089 6.73137 3.91331 6.3224 3.46937 6.06198C3.02544 5.80156 2.50373 5.70646 1.99646 5.7935C1.48919 5.88053 1.02902 6.14409 0.697282 6.53759C0.365543 6.9311 0.183594 7.42921 0.183594 7.94389C0.183594 8.45857 0.365543 8.95669 0.697282 9.35019C1.02902 9.74369 1.48919 10.0073 1.99646 10.0943C2.50373 10.1813 3.02544 10.0862 3.46937 9.82581C3.91331 9.56539 4.25089 9.15641 4.42245 8.67116H6.00063L8.517 13.0348H12.1534V14.4893L15.7897 12.3075L12.1534 10.1257L12.1824 11.5803ZM2.36427 8.67116C2.22043 8.67116 2.07982 8.62851 1.96022 8.5486C1.84062 8.46868 1.7474 8.3551 1.69236 8.22221C1.63731 8.08932 1.62291 7.94309 1.65097 7.80201C1.67903 7.66093 1.7483 7.53134 1.85001 7.42963C1.95172 7.32792 2.08131 7.25866 2.22238 7.23059C2.36346 7.20253 2.50969 7.21693 2.64258 7.27198C2.77548 7.32703 2.88906 7.42024 2.96897 7.53984C3.04889 7.65944 3.09154 7.80005 3.09154 7.94389C3.09154 8.13678 3.01492 8.32176 2.87853 8.45815C2.74214 8.59454 2.55715 8.67116 2.36427 8.67116Z"
        :fill="isSelected ? '#FFFFFF' : '#0D0E0F'"
      />
    </svg>

    <svg
      v-if="name === 'allflow'"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_42430_42988)">
        <path
          d="M13.1207 10.9951H12.1098L10.9825 7.99869L12.1098 5.00232H13.1207V6.41323L15.9134 4.23141L13.1207 2.0496V3.4605H11.1861L9.66612 7.16232C9.50533 6.80925 9.24636 6.5099 8.9201 6.29998C8.59384 6.09007 8.21408 5.97845 7.82612 5.97845C7.43817 5.97845 7.0584 6.09007 6.73214 6.29998C6.40588 6.5099 6.14691 6.80925 5.98612 7.16232L4.46612 3.4605H2.86612L1.04067 1.74414L-0.0429688 2.86414L1.33885 4.18778L-0.0429688 5.61323L1.06249 6.69687L2.71339 5.00232H3.54249L4.67703 7.99869L3.54249 10.9951H2.81521L1.04067 9.3005L-0.0429688 10.4205L1.33885 11.7441L-0.0429688 13.1696L1.06249 14.2532L2.73521 12.5369H4.46612L5.98612 8.8496C6.14691 9.20266 6.40588 9.50202 6.73214 9.71193C7.0584 9.92185 7.43817 10.0335 7.82612 10.0335C8.21408 10.0335 8.59384 9.92185 8.9201 9.71193C9.24636 9.50202 9.50533 9.20266 9.66612 8.8496L11.1861 12.5441H13.1207V13.9332L15.9134 11.7514L13.1207 9.5696V10.9951ZM8.51703 7.99869C8.5242 8.14538 8.48679 8.2908 8.40972 8.41582C8.33265 8.54084 8.21953 8.6396 8.08526 8.6991C7.95098 8.7586 7.80184 8.77605 7.65746 8.74916C7.51307 8.72227 7.38022 8.65229 7.27637 8.54844C7.17251 8.44459 7.10254 8.31173 7.07565 8.16735C7.04876 8.02297 7.06621 7.87382 7.12571 7.73955C7.18521 7.60527 7.28396 7.49216 7.40898 7.41509C7.53401 7.33802 7.67943 7.30061 7.82612 7.30778C8.00651 7.31659 8.17717 7.39221 8.30488 7.51992C8.43259 7.64763 8.50822 7.81829 8.51703 7.99869Z"
          :fill="isSelected ? '#FFFFFF' : '#0D0E0F'"
        />
      </g>
      <defs>
        <clipPath id="clip0_42430_42988">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
    <!-- 节点关联 -->
    <svg
      v-if="name === 'association' || name === 'disabelassociation'"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.0047 5.92871V7.17962H13.3247V13.7251H6.77923V7.17962H8.39377V5.92871H5.52832V14.9833H14.5829V5.92871H11.0047Z"
        :fill="name === 'association' ? '#0D0E0F' : '#bac0ca'"
      />
      <path
        d="M8.44336 5.87891V7.22949H6.8291V13.6748H13.2744V7.22949H10.9551V5.87891H14.6328V15.0332H5.47852V5.87891H8.44336ZM5.57812 14.9336H14.5332V5.97852H11.0547V7.12988H13.375V13.7754H6.72949V7.12988H8.34375V5.97852H5.57812V14.9336Z"
        :fill="name === 'association' ? '#0D0E0F' : '#bac0ca'"
      />
      <path
        d="M2.53064 2.93299H9.06882V9.47117H7.46155V10.7294H10.327V1.6748H1.27246V10.7294H4.85064V9.47117H2.53064V2.93299Z"
        :fill="name === 'association' ? '#0D0E0F' : '#bac0ca'"
      />
      <path
        d="M10.377 1.625V10.7793H7.41113V9.4209H9.01855V2.9834H2.58105V9.4209H4.90039V10.7793H1.22266V1.625H10.377ZM1.32227 10.6797H4.80078V9.52148H2.48047V2.88281H9.11914V9.52148H7.51172V10.6797H10.2773V1.72461H1.32227V10.6797Z"
        :fill="name === 'association' ? '#0D0E0F' : '#bac0ca'"
      />
    </svg>
    <!-- 批量扩展 -->
    <svg
      v-if="name === 'extension' || name === 'disabelextension'"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_42430_42999)">
        <path
          d="M15.305 11.4621C14.9267 11.1166 14.4337 10.922 13.9203 10.9156C13.407 10.9092 12.9093 11.0915 12.5224 11.4275L11.5902 10.8872V7.65258L8.68935 5.96947V4.78505C9.1535 4.62166 9.54469 4.30016 9.79379 3.87736C10.0429 3.45457 10.1339 2.9577 10.0506 2.47459C9.96735 1.99147 9.71525 1.55322 9.33886 1.23727C8.96246 0.921332 8.486 0.748047 7.9937 0.748047C7.5014 0.748047 7.02494 0.921332 6.64855 1.23727C6.27215 1.55322 6.02005 1.99147 5.9368 2.47459C5.85355 2.9577 5.94451 3.45457 6.19361 3.87736C6.44271 4.30016 6.8339 4.62166 7.29805 4.78505V5.96947L4.40414 7.65258V10.9011L3.47892 11.4275C3.09203 11.0915 2.59432 10.9092 2.08097 10.9156C1.56762 10.922 1.07464 11.1166 0.69631 11.4621C0.389351 11.7428 0.172218 12.1073 0.0720091 12.5101C-0.0281997 12.9129 -0.00704555 13.3361 0.132831 13.727C0.236648 14.0118 0.401726 14.2704 0.616504 14.485C0.831283 14.6995 1.09057 14.8646 1.3762 14.9689C1.66183 15.0732 1.96689 15.114 2.27003 15.0885C2.57317 15.063 2.86705 14.9719 3.13109 14.8214C3.51307 14.6111 3.81919 14.2868 4.00637 13.8941C4.19355 13.5015 4.25238 13.0603 4.17457 12.6327L5.03022 12.134L7.60414 13.6093L8.01457 13.8309L8.425 13.6093L10.992 12.134L11.2563 12.2864L11.8476 12.6327C11.7866 12.9873 11.8191 13.3517 11.9419 13.6901C12.0648 14.0285 12.2738 14.3293 12.5485 14.5631C12.8232 14.797 13.1542 14.9557 13.5091 15.0239C13.8639 15.0921 14.2305 15.0674 14.5728 14.9522C14.9152 14.837 15.2217 14.6352 15.4622 14.3666C15.7027 14.0981 15.8691 13.7719 15.945 13.4201C16.0209 13.0683 16.0037 12.7029 15.8952 12.3597C15.7867 12.0165 15.5905 11.7072 15.3259 11.4621H15.305ZM2.90848 13.2283C2.84808 13.4457 2.70613 13.6317 2.51196 13.7478C2.32099 13.8465 2.09967 13.87 1.8921 13.8135C1.68453 13.757 1.50596 13.6248 1.39196 13.4431C1.33584 13.3477 1.29922 13.2421 1.28423 13.1326C1.26925 13.023 1.27618 12.9116 1.30463 12.8047C1.33308 12.6979 1.38249 12.5976 1.45001 12.5099C1.51753 12.4221 1.60183 12.3485 1.69805 12.2933C1.7937 12.2375 1.89964 12.2013 2.00958 12.1871C2.11952 12.1728 2.23122 12.1806 2.33805 12.2102C2.44682 12.2365 2.54884 12.2852 2.63751 12.3532C2.72618 12.4212 2.79954 12.507 2.85283 12.605C2.95014 12.7982 2.97003 13.021 2.90848 13.2283ZM7.14501 2.8041C7.15045 2.58361 7.24227 2.37397 7.40084 2.21997C7.55942 2.06596 7.77218 1.97979 7.9937 1.97986C8.21576 1.978 8.42955 2.06359 8.58852 2.21797C8.74748 2.37235 8.83873 2.58303 8.8424 2.8041C8.83875 3.0258 8.74772 3.2372 8.58895 3.39269C8.43019 3.54817 8.2164 3.6353 7.9937 3.63527C7.88316 3.63618 7.77352 3.61541 7.67105 3.57413C7.56857 3.53285 7.47526 3.47188 7.39646 3.3947C7.31765 3.31752 7.25488 3.22564 7.21173 3.1243C7.16859 3.02297 7.14592 2.91416 7.14501 2.8041ZM10.2059 10.9703L7.9937 12.2379L5.78153 10.9773V8.44219L7.9937 7.17466L10.2059 8.44219V10.9703ZM14.6094 13.4292C14.4948 13.6199 14.31 13.7585 14.0942 13.8155C13.8785 13.8724 13.649 13.8432 13.4546 13.734C13.3585 13.6772 13.2746 13.6021 13.2078 13.5129C13.1409 13.4238 13.0924 13.3223 13.065 13.2145C13.0354 13.1081 13.0275 12.9969 13.0418 12.8874C13.0561 12.778 13.0924 12.6725 13.1485 12.5773C13.2606 12.384 13.445 12.2427 13.6613 12.1843C13.8777 12.1259 14.1085 12.1551 14.3033 12.2656C14.4007 12.3214 14.4859 12.396 14.5541 12.4849C14.6223 12.5739 14.6721 12.6754 14.7006 12.7837C14.7291 12.8919 14.7357 13.0047 14.72 13.1156C14.7044 13.2264 14.6667 13.333 14.6094 13.4292Z"
          :fill="name === 'extension' ? '#0D0E0F' : '#bac0ca'"
        />
      </g>
      <defs>
        <clipPath id="clip0_42430_42999">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
    <!-- 批量余额查询 -->
    <svg
      v-if="name === 'balanceselect' || name === 'disabelbalanceselect'"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_42430_43005)">
        <path
          d="M13.3306 10.2551C13.6365 9.54305 13.7924 8.77559 13.7887 8.00059C13.789 6.97917 13.5203 5.97569 13.0097 5.09104C12.4992 4.20638 11.7647 3.47172 10.8802 2.96091C9.9957 2.45011 8.9923 2.18115 7.97088 2.1811C6.94947 2.18104 5.94603 2.44988 5.06146 2.96059L4.33419 1.7024C5.43904 1.06392 6.69452 0.732476 7.97055 0.742404C9.24919 0.749088 10.5035 1.09276 11.6069 1.73877C13.1689 2.63988 14.3403 4.08912 14.894 5.80525C15.4477 7.52137 15.3441 9.382 14.6033 11.026L15.5778 11.5933L12.5451 13.1642L12.4287 9.73877L13.3306 10.2624V10.2551ZM2.60328 5.74604C2.13567 6.86944 2.03205 8.11119 2.30701 9.29655C2.58197 10.4819 3.22166 11.5512 4.13608 12.3541C5.0505 13.1569 6.19362 13.6528 7.40461 13.7721C8.61559 13.8913 9.83348 13.6278 10.8869 13.0188L11.6142 14.2769C10.5093 14.9154 9.25386 15.2469 7.97783 15.2369C6.68752 15.2389 5.41992 14.8975 4.3051 14.2479C2.76058 13.3433 1.60389 11.9009 1.05642 10.1967C0.508945 8.49257 0.60914 6.64638 1.33783 5.0115L0.363281 4.4515L3.38874 2.83695L3.51237 6.26968L2.60328 5.74604ZM5.45419 9.45513H9.45419C9.55063 9.45513 9.64312 9.41682 9.71132 9.34863C9.77952 9.28043 9.81783 9.18794 9.81783 9.0915C9.81783 8.99505 9.77952 8.90256 9.71132 8.83437C9.64312 8.76617 9.55063 8.72786 9.45419 8.72786H6.5451C6.06289 8.72786 5.60043 8.5363 5.25945 8.19533C4.91848 7.85435 4.72692 7.39189 4.72692 6.90968C4.72692 6.42747 4.91848 5.965 5.25945 5.62403C5.60043 5.28305 6.06289 5.0915 6.5451 5.0915H7.27237V4.36422H8.72692V5.0915H10.5451V6.54604H6.51601C6.41957 6.54604 6.32707 6.58435 6.25888 6.65255C6.19068 6.72074 6.15237 6.81323 6.15237 6.90968C6.15237 7.00612 6.19068 7.09861 6.25888 7.16681C6.32707 7.235 6.41957 7.27331 6.51601 7.27331H9.4251C9.90731 7.27331 10.3698 7.46487 10.7107 7.80585C11.0517 8.14682 11.2433 8.60928 11.2433 9.0915C11.2433 9.57371 11.0517 10.0362 10.7107 10.3771C10.3698 10.7181 9.90731 10.9097 9.4251 10.9097H8.69783V11.637H7.24328V10.9097H5.45419V9.45513Z"
          :fill="name === 'balanceselect' ? '#0D0E0F' : '#bac0ca'"
        />
      </g>
      <defs>
        <clipPath id="clip0_42430_43005">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
    <!-- 首笔手续费 -->
    <svg
      v-if="name === 'Firstpaymentfee' || name === 'disabelFirstpaymentfee'"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.84318 5.81747C3.0317 5.81747 3.21249 5.89409 3.34579 6.03049C3.47909 6.16688 3.55398 6.35186 3.55398 6.54474C4.67469 6.53942 5.76338 6.92699 6.63883 7.64293H8.17414C8.62329 7.64151 9.06765 7.73733 9.47803 7.9241C9.88842 8.11086 10.2555 8.38433 10.5553 8.72656H12.7943C13.4619 8.72653 14.116 8.91889 14.6817 9.28161C15.2474 9.64433 15.7018 10.1627 15.9929 10.7775C15.1182 11.953 13.9889 12.905 12.694 13.5586C11.399 14.2123 9.97352 14.5498 8.52954 14.5447C6.7835 14.5873 5.05589 14.1717 3.51133 13.3375C3.46166 13.478 3.37088 13.5995 3.25132 13.6854C3.13177 13.7713 2.98926 13.8174 2.84318 13.8175H0.710795C0.522281 13.8175 0.341487 13.7408 0.208187 13.6045C0.0748871 13.4681 0 13.2831 0 13.0902V6.54474C0 6.35186 0.0748871 6.16688 0.208187 6.03049C0.341487 5.89409 0.522281 5.81747 0.710795 5.81747H2.84318ZM3.55398 7.99929V11.6357C5.02387 12.6391 6.76341 13.1476 8.52954 13.0902C10.6033 13.0999 12.5993 12.2835 14.0951 10.8138L14.1946 10.7193L14.1093 10.6466C13.775 10.3756 13.3689 10.2135 12.9436 10.1811H11.2945C11.3459 10.42 11.3721 10.6638 11.3727 10.9084V11.6357H4.97557V10.1811H9.80187V10.1229C9.66704 9.83276 9.4589 9.5847 9.19897 9.40442C8.93905 9.22414 8.63678 9.11817 8.32341 9.09747H6.09152C5.76128 8.75082 5.36673 8.47512 4.93099 8.28654C4.49524 8.09797 4.02709 8.00031 3.55398 7.99929ZM2.13239 7.27202H1.42159V12.3629H2.13239V7.27202ZM12.0835 2.90838C12.6491 2.90838 13.1914 3.13825 13.5913 3.54742C13.9912 3.95659 14.2159 4.51154 14.2159 5.0902C14.2159 5.66885 13.9912 6.22381 13.5913 6.63298C13.1914 7.04215 12.6491 7.27202 12.0835 7.27202C11.518 7.27202 10.9756 7.04215 10.5757 6.63298C10.1758 6.22381 9.95113 5.66885 9.95113 5.0902C9.95113 4.51154 10.1758 3.95659 10.5757 3.54742C10.9756 3.13825 11.518 2.90838 12.0835 2.90838ZM12.0835 4.36293C11.895 4.36293 11.7142 4.43955 11.5809 4.57594C11.4476 4.71233 11.3727 4.89731 11.3727 5.0902C11.3727 5.28308 11.4476 5.46807 11.5809 5.60446C11.7142 5.74085 11.895 5.81747 12.0835 5.81747C12.272 5.81747 12.4528 5.74085 12.5861 5.60446C12.7194 5.46807 12.7943 5.28308 12.7943 5.0902C12.7943 4.89731 12.7194 4.71233 12.5861 4.57594C12.4528 4.43955 12.272 4.36293 12.0835 4.36293ZM7.10795 0.726562C7.6735 0.726563 8.21588 0.956432 8.61578 1.3656C9.01568 1.77477 9.24034 2.32973 9.24034 2.90838C9.24034 3.48704 9.01568 4.04199 8.61578 4.45116C8.21588 4.86033 7.6735 5.0902 7.10795 5.0902C6.54241 5.0902 6.00003 4.86033 5.60013 4.45116C5.20023 4.04199 4.97557 3.48704 4.97557 2.90838C4.97557 2.32973 5.20023 1.77477 5.60013 1.3656C6.00003 0.956432 6.54241 0.726563 7.10795 0.726562ZM7.10795 2.18111C6.91944 2.18111 6.73864 2.25773 6.60534 2.39412C6.47204 2.53051 6.39716 2.7155 6.39716 2.90838C6.39716 3.10127 6.47204 3.28625 6.60534 3.42264C6.73864 3.55903 6.91944 3.63565 7.10795 3.63565C7.29647 3.63565 7.47726 3.55903 7.61056 3.42264C7.74386 3.28625 7.81875 3.10127 7.81875 2.90838C7.81875 2.7155 7.74386 2.53051 7.61056 2.39412C7.47726 2.25773 7.29647 2.18111 7.10795 2.18111Z"
        :fill="name === 'Firstpaymentfee' ? '#0D0E0F' : '#bac0ca'"
      />
    </svg>
    <!-- 交易对手 -->
    <svg
      v-if="name === 'counterparty' || name === 'disabelcounterparty'"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_42430_43751)">
        <path
          d="M11.6951 10.0435C12.2672 9.44 12.6828 8.70548 12.9055 7.9042C13.1282 7.10293 13.1512 6.2593 12.9725 5.44708C12.7938 4.63486 12.4188 3.87879 11.8804 3.24498C11.342 2.61116 10.6565 2.11891 9.88382 1.81126C9.11117 1.50361 8.27492 1.38992 7.44818 1.48016C6.62145 1.57039 5.8294 1.86178 5.14131 2.32886C4.45322 2.79594 3.89003 3.42448 3.50099 4.15951C3.11195 4.89455 2.90891 5.71371 2.90962 6.54535C2.90625 7.84791 3.40658 9.10134 4.30598 10.0435C4.69858 9.41812 5.24347 8.90256 5.88964 8.54514C6.5358 8.18771 7.2621 8.00011 8.00053 7.9999C8.73637 7.99979 9.46029 8.18576 10.105 8.54053C10.7496 8.89529 11.2941 9.40731 11.6878 10.029L11.6951 10.0435ZM5.37508 11.1199L8.00053 13.7454L10.626 11.1199C10.3886 10.6261 10.0165 10.2094 9.55269 9.91771C9.08886 9.62605 8.55208 9.47132 8.00417 9.47132C7.45625 9.47132 6.91948 9.62605 6.45564 9.91771C5.9918 10.2094 5.61976 10.6261 5.38235 11.1199H5.37508ZM8.00053 15.8035L3.37508 11.1708C2.61317 10.4099 2.05078 9.47268 1.73775 8.44236C1.42472 7.41204 1.37072 6.32041 1.58053 5.26422C1.79035 4.20804 2.2575 3.21994 2.94058 2.3875C3.62366 1.55507 4.50157 0.904016 5.49648 0.492062C6.49138 0.0801087 7.57256 -0.0800224 8.64416 0.0258639C9.71576 0.13175 10.7447 0.500383 11.6397 1.09908C12.5348 1.69779 13.2683 2.50806 13.7752 3.45809C14.2822 4.40811 14.5469 5.46853 14.546 6.54535C14.5476 7.40499 14.3788 8.25641 14.0492 9.05036C13.7196 9.84431 13.2359 10.565 12.626 11.1708L8.00053 15.8035ZM8.00053 5.81808C8.19342 5.81808 8.3784 5.74146 8.51479 5.60507C8.65118 5.46868 8.7278 5.28369 8.7278 5.09081C8.7278 4.89792 8.65118 4.71294 8.51479 4.57655C8.3784 4.44016 8.19342 4.36354 8.00053 4.36354C7.80765 4.36354 7.62266 4.44016 7.48627 4.57655C7.34988 4.71294 7.27326 4.89792 7.27326 5.09081C7.27326 5.28369 7.34988 5.46868 7.48627 5.60507C7.62266 5.74146 7.80765 5.81808 8.00053 5.81808ZM8.00053 7.27263C7.42188 7.27263 6.86692 7.04276 6.45775 6.63359C6.04858 6.22442 5.81871 5.66946 5.81871 5.09081C5.81871 4.51215 6.04858 3.9572 6.45775 3.54803C6.86692 3.13886 7.42188 2.90899 8.00053 2.90899C8.57918 2.90899 9.13414 3.13886 9.54331 3.54803C9.95248 3.9572 10.1823 4.51215 10.1823 5.09081C10.1823 5.66946 9.95248 6.22442 9.54331 6.63359C9.13414 7.04276 8.57918 7.27263 8.00053 7.27263Z"
          :fill="name === 'counterparty' ? '#0D0E0F' : '#bac0ca'"
        />
      </g>
      <defs>
        <clipPath id="clip0_42430_43751">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
    <!-- 交易路径 -->
    <svg
      v-if="name === 'Tradingpath' || name === 'disabelTradingpath'"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_42465_9799)">
        <path
          d="M4.08879 10.5675C4.61361 10.7668 5.05197 11.1438 5.3276 11.6329C5.60323 12.1219 5.69869 12.6921 5.59738 13.2443C5.49607 13.7965 5.2044 14.2957 4.7731 14.655C4.3418 15.0144 3.79818 15.2112 3.23679 15.2112C2.6754 15.2112 2.13177 15.0144 1.70047 14.655C1.26917 14.2957 0.9775 13.7965 0.87619 13.2443C0.77488 12.6921 0.870343 12.1219 1.14597 11.6329C1.42161 11.1438 1.85996 10.7668 2.38479 10.5675H2.40079V5.46352C1.86702 5.27481 1.41714 4.90347 1.13068 4.41514C0.844219 3.92681 0.739613 3.35293 0.83535 2.79494C0.931087 2.23694 1.221 1.73075 1.65386 1.36584C2.08671 1.00093 2.63464 0.800781 3.20079 0.800781C3.76694 0.800781 4.31486 1.00093 4.74771 1.36584C5.18057 1.73075 5.47049 2.23694 5.56622 2.79494C5.66196 3.35293 5.55735 3.92681 5.27089 4.41514C4.98443 4.90347 4.53456 5.27481 4.00079 5.46352V7.99952C4.69317 7.48023 5.53531 7.19952 6.40079 7.19952H9.60079C10.1245 7.19977 10.634 7.02868 11.0514 6.71235C11.4689 6.39602 11.7714 5.95182 11.9128 5.44752C11.385 5.24281 10.9465 4.85811 10.6749 4.36141C10.4033 3.86471 10.316 3.28798 10.4285 2.73315C10.5409 2.17831 10.8459 1.68109 11.2895 1.32936C11.7331 0.977631 12.2867 0.794029 12.8526 0.811005C13.4185 0.827981 13.9601 1.04444 14.3818 1.42213C14.8035 1.79982 15.0781 2.31443 15.1571 2.87501C15.2362 3.43558 15.1144 4.00604 14.8135 4.48557C14.5126 4.9651 14.0519 5.32282 13.5128 5.49552C13.35 6.4168 12.8695 7.25188 12.1548 7.85553C11.44 8.45918 10.5363 8.79321 9.60079 8.79952H6.40079C5.87703 8.79928 5.36758 8.97037 4.95014 9.2867C4.5327 9.60302 4.2302 10.0472 4.08879 10.5515V10.5675ZM3.20079 11.9995C2.98861 11.9995 2.78513 12.0838 2.6351 12.2338C2.48507 12.3839 2.40079 12.5873 2.40079 12.7995C2.40079 13.0117 2.48507 13.2152 2.6351 13.3652C2.78513 13.5152 2.98861 13.5995 3.20079 13.5995C3.41296 13.5995 3.61644 13.5152 3.76647 13.3652C3.9165 13.2152 4.00079 13.0117 4.00079 12.7995C4.00079 12.5873 3.9165 12.3839 3.76647 12.2338C3.61644 12.0838 3.41296 11.9995 3.20079 11.9995ZM3.20079 2.39952C2.98861 2.39952 2.78513 2.48381 2.6351 2.63384C2.48507 2.78387 2.40079 2.98735 2.40079 3.19952C2.40079 3.4117 2.48507 3.61518 2.6351 3.76521C2.78513 3.91524 2.98861 3.99952 3.20079 3.99952C3.41296 3.99952 3.61644 3.91524 3.76647 3.76521C3.9165 3.61518 4.00079 3.4117 4.00079 3.19952C4.00079 2.98735 3.9165 2.78387 3.76647 2.63384C3.61644 2.48381 3.41296 2.39952 3.20079 2.39952ZM12.8008 2.39952C12.5886 2.39952 12.3851 2.48381 12.2351 2.63384C12.0851 2.78387 12.0008 2.98735 12.0008 3.19952C12.0008 3.4117 12.0851 3.61518 12.2351 3.76521C12.3851 3.91524 12.5886 3.99952 12.8008 3.99952C13.013 3.99952 13.2164 3.91524 13.3665 3.76521C13.5165 3.61518 13.6008 3.4117 13.6008 3.19952C13.6008 2.98735 13.5165 2.78387 13.3665 2.63384C13.2164 2.48381 13.013 2.39952 12.8008 2.39952Z"
          :fill="name === 'Tradingpath' ? '#0D0E0F' : '#bac0ca'"
        />
      </g>
      <defs>
        <clipPath id="clip0_42465_9799">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
    <!--  多层追溯-->
    <svg
      v-if="
        name === 'multilayerTraceability' ||
        name === 'dismultilayerTraceability'
      "
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_42746_25462)">
        <path
          d="M14.3076 7.35026L11.6071 2.63281H9.26562V4.20529H10.7017L12.9573 8.1365L10.7017 12.0677H9.26562V13.6402H11.6071L14.3076 8.92274H16.0012V7.35026H14.3076Z"
          :fill="name === 'multilayerTraceability' ? '#0D0E0F' : '#bac0ca'"
        />
        <path
          d="M10.2795 2.63499C10.0954 2.1104 9.73309 1.66826 9.25667 1.38673C8.78025 1.10519 8.22037 1.00238 7.67599 1.09647C7.1316 1.19056 6.63776 1.47549 6.28174 1.9009C5.92573 2.32632 5.73047 2.86481 5.73047 3.42123C5.73047 3.97764 5.92573 4.51614 6.28174 4.94155C6.63776 5.36696 7.1316 5.65189 7.67599 5.74598C8.22037 5.84007 8.78025 5.73726 9.25667 5.45573C9.73309 5.17419 10.0954 4.73206 10.2795 4.20747V2.63499ZM8.82778 3.42123C8.82778 3.57673 8.782 3.72874 8.69624 3.85804C8.61048 3.98734 8.48859 4.08811 8.34597 4.14762C8.20335 4.20713 8.04642 4.2227 7.89502 4.19236C7.74363 4.16202 7.60455 4.08714 7.4954 3.97718C7.38625 3.86723 7.31191 3.72713 7.2818 3.57462C7.25168 3.4221 7.26714 3.26401 7.32621 3.12035C7.38529 2.97668 7.48532 2.85389 7.61367 2.76749C7.74202 2.6811 7.89292 2.63499 8.04729 2.63499C8.25429 2.63499 8.45281 2.71782 8.59918 2.86527C8.74555 3.01272 8.82778 3.2127 8.82778 3.42123Z"
          :fill="name === 'multilayerTraceability' ? '#0D0E0F' : '#bac0ca'"
        />
        <path
          d="M5.70703 12.8544C5.71129 13.4076 5.9084 13.9416 6.26392 14.3632C6.61943 14.7848 7.11072 15.0671 7.65192 15.1608C8.19311 15.2545 8.74977 15.1535 9.22458 14.8757C9.6994 14.5978 10.0622 14.1607 10.2495 13.6407V12.0682C10.066 11.5427 9.70379 11.0996 9.22706 10.8174C8.75034 10.5351 8.18984 10.432 7.64484 10.5261C7.09984 10.6203 6.60551 10.9058 6.2494 11.3319C5.8933 11.758 5.6984 12.2974 5.69922 12.8544H5.70703ZM7.268 12.8544C7.268 12.6989 7.31378 12.5469 7.39954 12.4176C7.4853 12.2883 7.60719 12.1875 7.74981 12.128C7.89243 12.0685 8.04936 12.053 8.20076 12.0833C8.35216 12.1136 8.49122 12.1885 8.60038 12.2985C8.70953 12.4084 8.78386 12.5485 8.81398 12.701C8.8441 12.8536 8.82864 13.0116 8.76957 13.1553C8.71049 13.299 8.61046 13.4218 8.48211 13.5082C8.35375 13.5946 8.20286 13.6407 8.04849 13.6407C7.84149 13.6407 7.64297 13.5578 7.4966 13.4104C7.35023 13.2629 7.268 13.063 7.268 12.8544Z"
          :fill="name === 'multilayerTraceability' ? '#0D0E0F' : '#bac0ca'"
        />
        <path
          d="M3.5122 13.6421V16.0009L0 12.8559L3.5122 9.71094V12.0697V13.6421Z"
          :fill="name === 'multilayerTraceability' ? '#0D0E0F' : '#bac0ca'"
        />
        <path
          d="M6.46355 12.0703H1.14062V13.6428H6.46355V12.0703Z"
          :fill="name === 'multilayerTraceability' ? '#0D0E0F' : '#bac0ca'"
        />
        <path
          d="M3.5122 3.9312V6.28993L0 3.14496L3.5122 0V2.35872V3.9312Z"
          :fill="name === 'multilayerTraceability' ? '#0D0E0F' : '#bac0ca'"
        />
        <path
          d="M6.46355 2.35938H1.14062V3.93186H6.46355V2.35938Z"
          :fill="name === 'multilayerTraceability' ? '#0D0E0F' : '#bac0ca'"
        />
      </g>
      <defs>
        <clipPath id="clip0_42746_25462">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
    <!-- 新启旧停 -->
    <svg
      v-if="name === 'normalNewOldStop' || name === 'grayOutNewOldStop'"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.0804 10.7013C12.6714 10.6427 12.2545 10.7226 11.8963 10.9282C11.5381 11.1338 11.2594 11.4533 11.1046 11.8356H10.0222L7.48802 9.30802L10.0115 6.78863H11.1046C11.2652 7.18536 11.5592 7.51398 11.936 7.71814C12.3128 7.92231 12.7491 7.98931 13.1701 7.90766C13.591 7.82601 13.9703 7.6008 14.2431 7.27062C14.5159 6.94045 14.665 6.52588 14.665 6.09799C14.665 5.6701 14.5159 5.25553 14.2431 4.92535C13.9703 4.59518 13.591 4.36996 13.1701 4.28831C12.7491 4.20666 12.3128 4.27367 11.936 4.47783C11.5592 4.682 11.2652 5.01062 11.1046 5.40735H10.0222L6.80537 2.19779H4.89916C4.73962 1.80107 4.44664 1.47215 4.07053 1.26752C3.69442 1.06288 3.25865 0.995297 2.83804 1.07637C2.41743 1.15744 2.03823 1.38211 1.76554 1.71179C1.49286 2.04148 1.34372 2.45561 1.34372 2.88309C1.34372 3.31056 1.49286 3.72469 1.76554 4.05438C2.03823 4.38407 2.41743 4.60873 2.83804 4.6898C3.25865 4.77087 3.69442 4.70329 4.07053 4.49865C4.44664 4.29402 4.73962 3.9651 4.89916 3.56838H6.23806L8.74371 6.09045L6.23137 8.61786H4.89514C4.7727 8.31585 4.5723 8.05158 4.31432 7.85191C4.05633 7.65224 3.74997 7.5243 3.42637 7.48108H3.41872C3.39959 7.47841 3.37836 7.47631 3.35866 7.4744C3.28689 7.46759 3.21479 7.46491 3.14272 7.46638H3.13392C3.06133 7.46818 2.98891 7.47417 2.91702 7.48432C2.47702 7.54735 2.07455 7.76656 1.78342 8.10174C1.49229 8.43693 1.33203 8.86561 1.33203 9.30917C1.33203 9.75273 1.49229 10.1814 1.78342 10.5166C2.07455 10.8518 2.47702 11.071 2.91702 11.134C2.92753 11.1355 2.93786 11.1367 2.94819 11.1378L2.95795 11.139L2.97707 11.1413H2.98109C2.99199 11.1424 3.00309 11.1437 3.01323 11.1445C3.03541 11.1466 3.0576 11.1483 3.07979 11.1495H3.08992C3.47378 11.1691 3.85423 11.0689 4.17828 10.8626C4.50233 10.6563 4.75385 10.3544 4.89782 9.99876H6.24035L8.74601 12.5182L8.74486 12.5191L9.44931 13.2253L9.9164 13.2175H11.1067C11.2282 13.5173 11.4266 13.78 11.682 13.9791C11.9374 14.1782 12.2408 14.3068 12.5618 14.3519C12.8827 14.397 13.2099 14.3571 13.5105 14.2361C13.8111 14.1151 14.0745 13.9174 14.2743 13.6627C14.474 13.408 14.6032 13.1054 14.6486 12.7852C14.6941 12.4649 14.6544 12.1384 14.5334 11.8384C14.4125 11.5383 14.2145 11.2753 13.9595 11.0757C13.7045 10.8761 13.4013 10.747 13.0804 10.7013Z"
        :fill="name === 'normalNewOldStop' ? '#0D0E0F' : '#bac0ca'"
      />
    </svg>
    <!-- 单通道中转模型 -->
    <svg
      v-if="name === 'normalSingleChannel' || name === 'grayOutSingleChannel'"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.1797 12.626C15.1807 13.2753 14.9482 13.903 14.5254 14.3945C14.1024 14.8861 13.5166 15.209 12.876 15.3027C12.2355 15.3964 11.5824 15.2551 11.0371 14.9053C10.4919 14.5554 10.0911 14.02 9.90723 13.3975L5.18066 13.3975L5.02734 13.3936C4.22568 13.3534 3.47072 13.0005 2.9248 12.4102C2.37898 11.8198 2.08539 11.0383 2.10547 10.2334C2.12564 9.4287 2.45787 8.66363 3.03223 8.10156C3.60682 7.53944 4.3781 7.22457 5.18066 7.22461L6.12012 7.22461C6.43762 6.34263 7.27821 5.71111 8.26953 5.71094C9.26116 5.71094 10.1035 6.34232 10.4209 7.22461L11.335 7.22461L11.4502 7.2207C11.8477 7.19168 12.2184 7.0088 12.4844 6.71094C12.7503 6.413 12.8909 6.0227 12.876 5.62305C12.8609 5.22353 12.6917 4.84536 12.4043 4.56836C12.1169 4.29137 11.7335 4.13677 11.335 4.1377L6.60742 4.13769C6.42266 4.7599 6.02102 5.29513 5.47559 5.64453C4.93012 5.99393 4.27712 6.13468 3.63672 6.04102C2.99661 5.94734 2.41153 5.62553 1.98828 5.13477C1.56496 4.64367 1.33105 4.01546 1.33105 3.36621C1.33111 2.71703 1.565 2.08967 1.98828 1.59863C2.41153 1.10771 2.9965 0.786088 3.63672 0.692382C4.27712 0.59872 4.93012 0.739468 5.47559 1.08887C6.02087 1.43826 6.42268 1.97265 6.60742 2.59473L11.335 2.59473L11.4883 2.59863C12.2899 2.6388 13.0449 2.9917 13.5908 3.58203C14.1367 4.17235 14.4312 4.95381 14.4111 5.75879C14.391 6.56353 14.0578 7.32852 13.4834 7.89062C12.9088 8.45276 12.1375 8.76763 11.335 8.76758L10.4229 8.76758C10.1067 9.65234 9.26293 10.2861 8.26953 10.2861C7.27644 10.286 6.43435 9.65203 6.11816 8.76758L5.18066 8.76758L5.06543 8.77148C4.6673 8.7997 4.29591 8.98231 4.0293 9.28027C3.76264 9.57835 3.62174 9.96891 3.63672 10.3691C3.65176 10.7693 3.82127 11.1477 4.10937 11.4248C4.39749 11.7019 4.78154 11.8563 5.18066 11.8545L9.90723 11.8545C10.0932 11.2339 10.4952 10.7006 11.04 10.3525C11.5847 10.0047 12.236 9.86461 12.875 9.95801C13.514 10.0515 14.0985 10.3728 14.5215 10.8623C14.9445 11.3519 15.1782 11.978 15.1797 12.626ZM5.18066 3.36621C5.1806 3.13741 5.11304 2.91388 4.98633 2.72363C4.85956 2.5333 4.67956 2.38447 4.46875 2.29687C4.25798 2.20932 4.02551 2.1868 3.80176 2.23144C3.57829 2.27612 3.37311 2.38628 3.21191 2.54785C3.05058 2.7097 2.94003 2.91614 2.89551 3.14062C2.851 3.36512 2.87364 3.5981 2.96094 3.80957C3.04826 4.02106 3.19699 4.20192 3.38672 4.3291C3.57636 4.45611 3.79932 4.52441 4.02734 4.52441C4.33327 4.52433 4.62645 4.40159 4.84277 4.18457C5.05909 3.96753 5.1806 3.67313 5.18066 3.36621ZM13.6416 12.626C13.6416 12.3971 13.574 12.1728 13.4473 11.9824C13.3205 11.7921 13.1395 11.6442 12.9287 11.5566C12.7181 11.4692 12.4863 11.4457 12.2627 11.4902C12.0389 11.5349 11.8332 11.6458 11.6719 11.8076C11.5106 11.9695 11.401 12.1759 11.3564 12.4004C11.312 12.6247 11.3347 12.857 11.4219 13.0684C11.5092 13.2798 11.657 13.4607 11.8467 13.5879C12.0363 13.715 12.2592 13.7832 12.4873 13.7832C12.7933 13.7832 13.0874 13.6614 13.3037 13.4443C13.5199 13.2273 13.6416 12.9328 13.6416 12.626Z"
        :fill="name === 'normalSingleChannel' ? '#0D0E0F' : '#bac0ca'"
      />
    </svg>

    <!--  交易所扩展-->
    <svg
      v-if="name === 'exchangeexpansion' || name === 'disabelexchangeexpansion'"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_42484_32127)">
        <path
          d="M20 7.85065L16.2073 4.47939V7.00783H15.5668L12.6422 1.95094H11.0577C10.8823 1.45996 10.5593 1.03523 10.1331 0.734929C9.70683 0.434627 9.19818 0.273438 8.67678 0.273438C8.15538 0.273438 7.64674 0.434627 7.22051 0.734929C6.79427 1.03523 6.4713 1.45996 6.29583 1.95094H4.74505L1.82891 7.00783H0V8.69346H1.82891L4.74505 13.7504H6.29583C6.47299 14.2385 6.79615 14.6602 7.22138 14.9582C7.64661 15.2563 8.15329 15.4162 8.67257 15.4162C9.19184 15.4162 9.69852 15.2563 10.1238 14.9582C10.549 14.6602 10.8721 14.2385 11.0493 13.7504H12.6422L15.5668 8.69346H16.2073V11.2219L20 7.85065ZM8.681 1.95094C8.84769 1.95094 9.01064 2.00037 9.14924 2.09298C9.28784 2.18559 9.39586 2.31722 9.45965 2.47123C9.52345 2.62523 9.54014 2.79469 9.50762 2.95818C9.4751 3.12167 9.39482 3.27185 9.27696 3.38972C9.15909 3.50759 9.00891 3.58786 8.84542 3.62038C8.68193 3.6529 8.51247 3.63621 8.35846 3.57242C8.20446 3.50863 8.07283 3.4006 7.98022 3.262C7.88761 3.1234 7.83818 2.96045 7.83818 2.79376C7.83818 2.57023 7.92698 2.35586 8.08504 2.1978C8.24309 2.03974 8.45747 1.95094 8.681 1.95094ZM8.681 13.7504C8.5143 13.7504 8.35135 13.7009 8.21275 13.6083C8.07415 13.5157 7.96613 13.3841 7.90234 13.2301C7.83854 13.0761 7.82185 12.9066 7.85437 12.7431C7.88689 12.5796 7.96717 12.4294 8.08504 12.3116C8.2029 12.1937 8.35308 12.1134 8.51657 12.0809C8.68006 12.0484 8.84952 12.0651 9.00353 12.1289C9.15753 12.1927 9.28916 12.3007 9.38177 12.4393C9.47438 12.5779 9.52381 12.7408 9.52381 12.9075C9.52381 13.1311 9.43501 13.3454 9.27696 13.5035C9.1189 13.6616 8.90452 13.7504 8.681 13.7504ZM11.673 12.0647H11.0577C10.8823 11.5737 10.5593 11.149 10.1331 10.8487C9.70683 10.5484 9.19818 10.3872 8.67678 10.3872C8.15538 10.3872 7.64674 10.5484 7.22051 10.8487C6.79427 11.149 6.4713 11.5737 6.29583 12.0647H5.72271L3.28698 7.85065L5.72271 3.63657H6.29583C6.47299 4.12469 6.79615 4.54642 7.22138 4.84446C7.64661 5.14249 8.15329 5.30238 8.67257 5.30238C9.19184 5.30238 9.69852 5.14249 10.1238 4.84446C10.549 4.54642 10.8721 4.12469 11.0493 3.63657H11.6646L14.1003 7.85065L11.673 12.0647Z"
          :fill="name === 'exchangeexpansion' ? '#0D0E0F' : '#bac0ca'"
        />
      </g>
      <defs>
        <clipPath id="clip0_42484_32127">
          <rect width="20" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>

    <!-- select下拉 -->
    <svg
      v-if="name === 'selectdown'"
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.39584 3C8.82107 3 9.0522 3.4971 8.77815 3.82224L5.38353 7.84971C5.18376 8.08673 4.81868 8.08673 4.61891 7.84971L1.22429 3.82224C0.950235 3.4971 1.18137 3 1.6066 3H8.39584Z"
        fill="#87909F"
      />
    </svg>
    <svg
      v-if="name === 'selectup'"
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.39584 7.30273C8.82107 7.30273 9.0522 6.80564 8.77815 6.4805L5.38353 2.45302C5.18376 2.216 4.81868 2.216 4.61891 2.45302L1.22429 6.4805C0.950235 6.80564 1.18137 7.30273 1.6066 7.30273H8.39584Z"
        fill="#87909F"
      />
    </svg>

    <!-- 同时段 -->
    <svg
      v-if="name === 'iportime'"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.834 3.33398H11.834"
        stroke="#0D0E0F"
        stroke-width="1.4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.16602 2V4.66667"
        stroke="#0D0E0F"
        stroke-width="1.4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.16732 3.33398H1.83398"
        stroke="#0D0E0F"
        stroke-width="1.4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.50065 8H1.83398"
        stroke="#0D0E0F"
        stroke-width="1.4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.16602 6.66602V9.33268"
        stroke="#0D0E0F"
        stroke-width="1.4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.4993 8H7.16602"
        stroke="#0D0E0F"
        stroke-width="1.4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.834 12.666H11.834"
        stroke="#0D0E0F"
        stroke-width="1.4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.16602 11.334V14.0007"
        stroke="#0D0E0F"
        stroke-width="1.4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.16732 12.666H1.83398"
        stroke="#0D0E0F"
        stroke-width="1.4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- 刷新图标 -->
    <svg
      v-if="name === 'tworefresh'"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5 2V6"
        stroke="#05ABFA"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.5 6V10"
        stroke="#05ABFA"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.5 6C10.5 3.51472 8.48528 1.5 6 1.5C4.72863 1.5 3.5804 2.02724 2.76203 2.875M1.5 6C1.5 8.48528 3.51472 10.5 6 10.5C7.2139 10.5 8.31555 10.0194 9.125 9.23798"
        stroke="#05ABFA"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-if="name === 'refresh'"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.3033 15.3033C13.9461 16.6605 12.0711 17.5 10 17.5C5.85787 17.5 2.5 14.1421 2.5 10C2.5 5.85787 5.85787 2.5 10 2.5C12.0711 2.5 13.9461 3.33947 15.3033 4.69671C15.9941 5.38754 16.5 6.08333 16.5 6.08333"
        stroke="#0D0E0F"
        stroke-width="1.5"
        stroke-linecap="square"
        stroke-linejoin="round"
      />
      <path
        d="M17.5 3.3335V7.0835H13.75"
        stroke="#0D0E0F"
        stroke-width="1.5"
        stroke-linecap="square"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="name === 'newcanvasrefresh'"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 2.66602V7.99935"
        stroke="#0D0E0F"
        stroke-width="1.4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2 8V13.3333"
        stroke="#0D0E0F"
        stroke-width="1.4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14 8C14 4.6863 11.3137 2 8 2C6.30483 2 4.77387 2.70299 3.6827 3.83333M2 8C2 11.3137 4.6863 14 8 14C9.61853 14 11.0874 13.3591 12.1667 12.3173"
        stroke="#0D0E0F"
        stroke-width="1.4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-if="name === 'newrefresh'"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.2426 12.2426C11.1569 13.3284 9.65687 14 8 14C4.6863 14 2 11.3137 2 8C2 4.6863 4.6863 2 8 2C9.65687 2 11.1569 2.67157 12.2426 3.75737C12.7953 4.31003 13.2 4.86667 13.2 4.86667"
        stroke="#0D0E0F"
        stroke-width="1.4"
        stroke-linecap="square"
        stroke-linejoin="round"
      />
      <path
        d="M14 2.66797V5.66797H11"
        stroke="#0D0E0F"
        stroke-width="1.4"
        stroke-linecap="square"
        stroke-linejoin="round"
      />
    </svg>

    <!-- 加号图标 -->
    <svg
      v-if="name === 'addHash'"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.375 1.75H2.625C2.14175 1.75 1.75 2.14175 1.75 2.625V11.375C1.75 11.8582 2.14175 12.25 2.625 12.25H11.375C11.8582 12.25 12.25 11.8582 12.25 11.375V2.625C12.25 2.14175 11.8582 1.75 11.375 1.75Z"
        stroke="#05ABFA"
        stroke-width="1.2"
        stroke-linejoin="round"
      />
      <path
        d="M7 4.66663V9.33329"
        stroke="#05ABFA"
        stroke-width="1.2"
        stroke-linejoin="round"
      />
      <path
        d="M4.6665 7H9.33317"
        stroke="#05ABFA"
        stroke-width="1.2"
        stroke-linejoin="round"
      />
    </svg>

    <!-- 链图标 -->
    <svg
      v-if="name === 'blockchain_1'"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_42143_46997)">
        <mask
          id="mask0_42143_46997"
          style="mask-type: luminance"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="18"
          height="18"
        >
          <path d="M18 0H0V18H18V0Z" fill="white" />
        </mask>
        <g mask="url(#mask0_42143_46997)">
          <circle
            cx="9"
            cy="9"
            r="8.8875"
            fill="white"
            stroke="#A2A9B6"
            stroke-width="0.225"
          />
          <path
            d="M9.27112 12.3449L13.4866 9.90186L9.27112 15.7292L5.05566 9.90251L9.27112 12.3449Z"
            fill="#353535"
          />
          <path
            d="M5.05566 9.90283L9.27112 12.3452V15.7295L5.05566 9.90283Z"
            fill="#7A7A7A"
          />
          <path
            d="M9.27014 2.25708L13.4834 9.1174L9.27014 11.5622L5.05469 9.11806L9.27014 2.25708Z"
            fill="#7A7A7A"
          />
          <path
            d="M5.05469 9.11798L9.27014 7.43201V11.5621L5.05469 9.11798Z"
            fill="#474747"
          />
          <path
            d="M9.27051 2.25684L13.4838 9.11715L9.27051 11.5619V2.25684Z"
            fill="#343434"
          />
          <path
            d="M9.27051 7.43213L13.4838 9.11745L9.27051 11.5622V7.43213Z"
            fill="#181818"
          />
          <path
            d="M9.27051 7.43213L13.4838 9.11745L9.27051 11.5622V7.43213Z"
            fill="#181818"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_42143_46997">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
    <svg
      v-if="name === 'blockchain_2'"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_42143_47009)">
        <circle cx="9" cy="9" r="9" fill="#202021" />
        <g clip-path="url(#clip1_42143_47009)">
          <path
            d="M7.70857 8.99241L8.99907 7.70137L10.2899 8.99241L8.99907 10.2845L7.70821 8.99241H7.70857ZM11.8177 8.99241L13.1086 7.70137L14.3996 8.99241L13.1086 10.2833L11.8177 8.99241ZM3.59961 8.99241L4.89047 7.70137L6.18152 8.99241L4.89047 10.2833L3.59961 8.99241ZM5.63782 6.9542L8.99371 3.6001L10.2846 4.89096L6.9294 8.2456L5.63782 6.9542Z"
            fill="#F5B638"
          />
          <path
            d="M11.0698 8.24548L7.71514 4.89084L9.00619 3.59998L12.3603 6.95426L11.0692 8.2453L11.0698 8.24548ZM6.92954 9.75697L10.2842 13.1116L8.99331 14.4027L5.63867 11.048L6.92954 9.75697Z"
            fill="#F5B638"
          />
          <path
            d="M12.3623 11.0479L9.00766 14.4025L7.7168 13.1115L11.0714 9.75684L12.3623 11.0479Z"
            fill="#F5B638"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_42143_47009">
          <rect width="18" height="18" fill="white" />
        </clipPath>
        <clipPath id="clip1_42143_47009">
          <rect
            width="10.8"
            height="10.8027"
            fill="white"
            transform="translate(3.59961 3.6001)"
          />
        </clipPath>
      </defs>
    </svg>
    <svg
      v-if="name === 'blockchain_3'"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_42143_47015)">
        <circle cx="9" cy="9" r="9" fill="#B92932" />
        <g clip-path="url(#clip1_42143_47015)">
          <mask
            id="mask0_42143_47015"
            style="mask-type: luminance"
            maskUnits="userSpaceOnUse"
            x="4"
            y="4"
            width="10"
            height="11"
          >
            <path
              d="M13.9496 4.7251H4.72461V14.6251H13.9496V4.7251Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_42143_47015)">
            <path
              d="M8.69685 14.6112C8.66357 14.6126 8.63025 14.6093 8.59783 14.6014C8.45042 14.573 8.31323 14.504 8.20083 14.4017C8.08843 14.2995 8.00502 14.1678 7.95946 14.0206L4.80497 5.89625C4.74183 5.75856 4.71513 5.60612 4.72759 5.45437C4.74006 5.30263 4.79123 5.15697 4.87593 5.03216C4.95348 4.9353 5.05167 4.85816 5.16286 4.80674C5.27405 4.75532 5.39526 4.731 5.51706 4.73567C5.56942 4.73593 5.6217 4.73981 5.67356 4.74729L11.7621 5.58433C11.9401 5.61414 12.1053 5.69839 12.2363 5.82613L13.7049 7.33944C13.8439 7.48763 13.9269 7.68211 13.939 7.88781C13.951 8.0935 13.8913 8.29686 13.7706 8.4612L9.36768 14.2334C9.29155 14.3452 9.19143 14.4374 9.07509 14.503C8.95876 14.5685 8.82933 14.6055 8.69685 14.6112ZM5.51898 5.46166C5.48801 5.45871 5.4569 5.46548 5.42973 5.48106C5.4279 5.53205 5.43774 5.58276 5.45847 5.62909L8.61282 13.7513C8.64954 13.8481 8.69176 13.8819 8.6974 13.8819C8.70304 13.8819 8.74842 13.8631 8.80948 13.7804L13.2125 8.0072C13.2298 7.98337 13.2376 7.95359 13.2341 7.92405C13.2336 7.8956 13.2225 7.86843 13.2032 7.84812L11.7339 6.33468C11.7125 6.31972 11.6889 6.30834 11.664 6.30096L5.58472 5.46775C5.56304 5.4636 5.54103 5.46156 5.51898 5.46166Z"
              fill="white"
            />
          </g>
          <path
            d="M8.55654 14.5481C8.46386 14.5397 8.37823 14.4936 8.31842 14.4202C8.25862 14.3468 8.22951 14.252 8.23749 14.1565L8.69282 9.02147L5.07351 5.70943C5.00712 5.64441 4.9679 5.55532 4.96416 5.46104C4.96042 5.36675 4.99245 5.27467 5.05347 5.20429C5.11449 5.13391 5.19971 5.09075 5.29108 5.08395C5.38245 5.07716 5.47281 5.10726 5.54301 5.16788L9.29352 8.6009C9.3349 8.63863 9.36708 8.68585 9.38748 8.73876C9.40788 8.79166 9.41593 8.84876 9.41096 8.90545L8.9416 14.2242C8.93156 14.3133 8.89013 14.3955 8.82516 14.4552C8.76019 14.5149 8.6762 14.548 8.58913 14.5481H8.55654Z"
            fill="white"
          />
          <path
            d="M8.74781 9.03708C8.71214 8.96894 8.69881 8.89074 8.70981 8.81415C8.72081 8.73757 8.75556 8.6667 8.80887 8.61212L11.6253 5.71102C11.6923 5.64879 11.7799 5.61542 11.8701 5.61779C11.9603 5.62017 12.0461 5.65811 12.11 5.72378C12.1738 5.78946 12.2107 5.87786 12.213 5.97074C12.2154 6.06363 12.1831 6.15391 12.1227 6.22296L10.1287 8.27654L13.2315 7.63824C13.2777 7.62636 13.3259 7.62429 13.373 7.63215C13.42 7.64002 13.4651 7.65766 13.5053 7.684C13.5456 7.71034 13.5803 7.74483 13.6072 7.78539C13.6341 7.82594 13.6528 7.8717 13.662 7.91991C13.6712 7.96811 13.6709 8.01774 13.6609 8.06579C13.6509 8.11384 13.6316 8.1593 13.6041 8.19942C13.5766 8.23954 13.5414 8.27348 13.5007 8.29918C13.4601 8.32488 13.4148 8.3418 13.3676 8.34892L9.12339 9.22407C9.10177 9.22826 9.07976 9.22992 9.05779 9.22903C8.99407 9.22901 8.93157 9.21114 8.87696 9.17733C8.82235 9.14352 8.77771 9.09504 8.74781 9.03708Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_42143_47015">
          <rect width="18" height="18" fill="white" />
        </clipPath>
        <clipPath id="clip1_42143_47015">
          <rect
            width="9.225"
            height="9.9"
            fill="white"
            transform="translate(4.72461 4.7251)"
          />
        </clipPath>
      </defs>
    </svg>
    <!-- 设置图标 -->

    <svg
      v-if="name === 'setupIcon'"
      :width="iconWidth ? iconWidth : '20'"
      :height="iconWidth ? iconWidth : '20'"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3341 13.6673L14.6673 8.00065L11.3341 2.33398H4.66738L1.33398 8.00065L4.66738 13.6673H11.3341Z"
        stroke="#0D0E0F"
        stroke-width="1.4"
        stroke-linejoin="round"
      />
      <path
        d="M8.00065 9.66732C8.92112 9.66732 9.66732 8.92112 9.66732 8.00065C9.66732 7.08018 8.92112 6.33398 8.00065 6.33398C7.08018 6.33398 6.33398 7.08018 6.33398 8.00065C6.33398 8.92112 7.08018 9.66732 8.00065 9.66732Z"
        stroke="#0D0E0F"
        stroke-width="1.4"
        stroke-linejoin="round"
      />
    </svg>

    <!-- 快捷键图标 -->
    <svg
      v-if="name === 'shortcut-keys'"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.15168 4.96974C3.50093 4.96974 4.107 4.96974 4.96986 4.96974C4.96986 4.07781 4.96986 3.47174 4.96986 3.15156C4.96986 2.1474 4.15583 1.33337 3.15168 1.33337C2.14752 1.33337 1.3335 2.1474 1.3335 3.15156C1.3335 4.15571 2.14752 4.96974 3.15168 4.96974Z"
        stroke="#0D0E0F"
        stroke-width="1.2"
        stroke-linejoin="round"
      />
      <path
        d="M3.15168 11.0303H4.96986V12.8484C4.96986 13.8526 4.15583 14.6666 3.15168 14.6666C2.14752 14.6666 1.3335 13.8526 1.3335 12.8484C1.3335 11.8443 2.14752 11.0303 3.15168 11.0303Z"
        stroke="#0D0E0F"
        stroke-width="1.2"
        stroke-linejoin="round"
      />
      <path
        d="M11.0303 4.96973H4.96973V11.0303H11.0303V4.96973Z"
        stroke="#0D0E0F"
        stroke-width="1.2"
        stroke-linejoin="round"
      />
      <path
        d="M12.8485 4.96974H11.0303V3.15156C11.0303 2.1474 11.8443 1.33337 12.8485 1.33337C13.8526 1.33337 14.6666 2.1474 14.6666 3.15156C14.6666 4.15571 13.8526 4.96974 12.8485 4.96974Z"
        stroke="#0D0E0F"
        stroke-width="1.2"
        stroke-linejoin="round"
      />
      <path
        d="M12.8485 11.0303C13.8526 11.0303 14.6666 11.8443 14.6666 12.8484C14.6666 13.8526 13.8526 14.6666 12.8485 14.6666C11.8443 14.6666 11.0303 13.8526 11.0303 12.8484V11.0303H12.8485Z"
        stroke="#0D0E0F"
        stroke-width="1.2"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="name === 'refreshConfiguration'"
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.39584 3C8.82107 3 9.0522 3.4971 8.77815 3.82224L5.38353 7.84971C5.18376 8.08673 4.81868 8.08673 4.61891 7.84971L1.22429 3.82224C0.950235 3.4971 1.18137 3 1.6066 3H8.39584Z"
        fill="#87909F"
      />
    </svg>
    <svg
      v-if="name === 'joinSurvey'"
      width="14"
      height="14"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.7266 13.0918H17.1826V14.7285H14.7266V17.1826H13.0898V14.7285H10.6367V13.0918H13.0898V10.6367H14.7266V13.0918ZM14.7275 0.818359C14.9443 0.818383 15.1523 0.904421 15.3057 1.05762C15.4591 1.21106 15.5459 1.41972 15.5459 1.63672V9.28027C15.0339 9.09923 14.4832 9.00001 13.9092 9C11.198 9 9 11.198 9 13.9092C9.00002 15.1666 9.47345 16.3131 10.251 17.1816H1.63672C1.41972 17.1816 1.21106 17.0958 1.05762 16.9424C0.904394 16.7891 0.818477 16.581 0.818359 16.3643V1.63672C0.818359 1.41972 0.904178 1.21106 1.05762 1.05762C1.21106 0.904178 1.41972 0.818359 1.63672 0.818359H14.7275ZM4.09082 13.9092H7.36426V12.2725H4.09082V13.9092ZM4.09082 10.6367H9V9H4.09082V10.6367ZM4.09082 7.36426H12.2725V4.09082H4.09082V7.36426Z"
        fill="#fff"
      />
    </svg>
    <svg
      v-if="name === 'againIcon'"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5 2V6"
        :stroke="iconColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.5 6V10"
        :stroke="iconColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.5 6C10.5 3.51472 8.48528 1.5 6 1.5C4.72863 1.5 3.5804 2.02724 2.76203 2.875M1.5 6C1.5 8.48528 3.51472 10.5 6 10.5C7.2139 10.5 8.31555 10.0194 9.125 9.23798"
        :stroke="iconColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="name === 'failureIcon'"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 11C7.3807 11 8.6307 10.4404 9.53553 9.53553C10.4404 8.6307 11 7.3807 11 6C11 4.6193 10.4404 3.3693 9.53553 2.46446C8.6307 1.55964 7.3807 1 6 1C4.6193 1 3.3693 1.55964 2.46446 2.46446C1.55964 3.3693 1 4.6193 1 6C1 7.3807 1.55964 8.6307 2.46446 9.53553C3.3693 10.4404 4.6193 11 6 11Z"
        stroke="#FE445C"
        stroke-width="1.02857"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6 9.25C6.34518 9.25 6.625 8.97018 6.625 8.625C6.625 8.27983 6.34518 8 6 8C5.65483 8 5.375 8.27983 5.375 8.625C5.375 8.97018 5.65483 9.25 6 9.25Z"
        fill="#FE445C"
      />
      <path
        d="M6 3V7"
        stroke="#FE445C"
        stroke-width="1.02857"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="name === 'aiModelIcon'"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_42673_16508)">
        <path
          d="M14.4277 4.28809V11.7109L8 15.4229L1.57227 11.7109V4.28809L8 0.576172L14.4277 4.28809Z"
          stroke="#0E0E0E"
        />
        <path d="M10.5181 10.8395V5H11.797V10.8395H10.5181Z" fill="black" />
        <path
          d="M8.50293 10.8395L8.00648 9.39228H5.63364L5.12878 10.8395H3.79932L5.97863 5H7.69515L9.85764 10.8395H8.50293ZM6.00387 8.33208H7.63625L6.87896 6.11911H6.77799L6.00387 8.33208Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_42673_16508">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
    <svg
      v-if="name === 'sameIpIcon'"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.08594 4.34277H9.32205C10.5286 4.34277 11.2002 5.17869 11.2002 6.21153C11.2002 7.26045 10.5205 8.0602 9.30998 8.0602H8.24823V9.82849H7.08594V4.34277ZM8.24421 5.29122V7.13185H8.85954C9.57944 7.13185 10.0178 6.90277 10.0178 6.21153C10.0178 5.61675 9.6639 5.29122 9.08074 5.29122H8.24421Z"
        fill="#0E0E0E"
      />
      <path
        d="M5.71518 9.82849H4.34375V4.34277H5.71518V9.82849Z"
        fill="#0E0E0E"
      />
      <path
        d="M13.6579 8.04067V1.93457H1.27344V12.3631H9.02017"
        stroke="#0E0E0E"
      />
      <path
        d="M12.5709 13.7145C13.8332 13.7145 14.8566 12.6911 14.8566 11.4288C14.8566 10.1664 13.8332 9.14307 12.5709 9.14307C11.3085 9.14307 10.2852 10.1664 10.2852 11.4288C10.2852 12.6911 11.3085 13.7145 12.5709 13.7145Z"
        stroke="#0E0E0E"
        stroke-width="0.8"
      />
      <path
        d="M12.5703 10.7998V11.6569H13.4275"
        stroke="#0E0E0E"
        stroke-width="0.8"
        stroke-linecap="square"
      />
    </svg>
    <svg
      v-if="name === 'switchIcon'"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.25 5.54102H1.75"
        :stroke="iconColor ? iconColor : '#EBA43F'"
        stroke-width="1.4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.75 2.04102L12.25 5.54102"
        :stroke="iconColor ? iconColor : '#EBA43F'"
        stroke-width="1.4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.98242 8.45898H12.4824"
        :stroke="iconColor ? iconColor : '#EBA43F'"
        stroke-width="1.4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.98242 8.45898L5.48244 11.959"
        :stroke="iconColor ? iconColor : '#EBA43F'"
        stroke-width="1.4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="name === 'downloadicon'"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.95795 0.29791V9.73334M7.95795 9.73334L4.61732 6.39271M7.95795 9.73334L11.2986 6.39271"
        stroke="#0D0E0F"
        stroke-width="1.4"
      />
      <path
        d="M1.2002 9.73438V13.9844C1.2002 14.4538 1.58075 14.8344 2.0502 14.8344H13.9502C14.4196 14.8344 14.8002 14.4538 14.8002 13.9844V9.73438"
        stroke="#0D0E0F"
        stroke-width="1.4"
      />
    </svg>
    <svg
      v-if="name === 'downloadsvg'"
      width="16"
      height="16"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_43467_23674)">
        <path
          d="M12.7347 2.9089L9.93697 0.238802C9.77691 0.0853205 9.56367 -0.000257671 9.34191 5.82813e-07H2.36287C2.13412 0.000225174 1.9148 0.0911842 1.75304 0.252919C1.59127 0.414655 1.50027 0.633956 1.5 0.862707V13.1371C1.50027 13.3659 1.59127 13.5852 1.75303 13.747C1.91479 13.9087 2.13411 13.9997 2.36287 14H12.139C12.3677 13.9997 12.587 13.9087 12.7487 13.747C12.9105 13.5852 13.0014 13.3659 13.0017 13.1371V3.53314C13.0015 3.41647 12.9777 3.30105 12.9319 3.19378C12.886 3.08651 12.8189 2.98961 12.7347 2.9089ZM10.1232 1.90074L11.3038 3.0277H10.1232V1.90074ZM11.9278 12.926H2.57384V11.8262H9.99416C10.1486 11.8262 10.2175 11.7573 10.2175 11.6028V7.85532C10.2175 7.70088 10.1486 7.63197 9.99416 7.63197H2.57384V1.07384H9.04931V3.56471C9.04944 3.70718 9.10614 3.84377 9.20693 3.94446C9.30771 4.04515 9.44436 4.10171 9.58683 4.10171H11.929L11.9278 12.926ZM4.01327 10.1412C3.95658 10.0965 3.86289 10.0595 3.73492 10.0307L3.34863 9.94225C3.25656 9.92348 3.16693 9.89427 3.08148 9.85518C3.00095 9.81767 2.92655 9.76817 2.86084 9.70837C2.79196 9.64475 2.7382 9.56652 2.70351 9.47941C2.66539 9.3828 2.64664 9.27962 2.64835 9.17577C2.64521 9.01385 2.69438 8.85523 2.78854 8.72346C2.88256 8.59482 3.01133 8.49566 3.15973 8.43765C3.32256 8.37386 3.49625 8.34238 3.6711 8.34498C3.96642 8.34498 4.20998 8.4205 4.39498 8.56935C4.58303 8.72058 4.6796 8.92034 4.68232 9.16339V9.2121H4.08235L4.07929 9.16729C4.07625 9.12552 4.06474 9.0848 4.04545 9.04763C4.02616 9.01045 3.99951 8.9776 3.9671 8.95106C3.89667 8.8903 3.79738 8.86009 3.6689 8.86009C3.54873 8.86009 3.45335 8.88606 3.38563 8.93731C3.35462 8.95983 3.32967 8.98967 3.313 9.02417C3.29633 9.05867 3.28845 9.09676 3.29008 9.13504C3.29008 9.26013 3.39191 9.34194 3.60033 9.38488L3.9907 9.47245C4.08588 9.49183 4.17877 9.52112 4.26785 9.55986C4.35056 9.59708 4.42767 9.64563 4.49698 9.70412C4.57099 9.76725 4.62849 9.84747 4.6645 9.93783C4.70429 10.0398 4.72367 10.1486 4.72152 10.2581C4.72152 10.5219 4.62275 10.7333 4.42807 10.8861C4.23697 11.0366 3.97389 11.1132 3.64633 11.1137H3.62783C3.49725 11.1137 3.36719 11.0973 3.24069 11.065C3.13317 11.0387 3.03089 10.9943 2.93824 10.9338C2.86126 10.8814 2.79391 10.8161 2.73915 10.7408C2.68868 10.6724 2.65007 10.5961 2.62493 10.5149C2.60204 10.4377 2.59004 10.3578 2.58929 10.2773V10.2286H3.20623L3.20946 10.2732C3.21608 10.3645 3.25783 10.4392 3.33709 10.5017C3.41635 10.5641 3.53074 10.5977 3.67297 10.5977C3.80875 10.5977 3.91466 10.5699 3.98662 10.5151C4.01917 10.4913 4.04545 10.46 4.06319 10.4238C4.08093 10.3876 4.0896 10.3476 4.08846 10.3073C4.08897 10.2354 4.06419 10.181 4.01327 10.1413V10.1412ZM4.76362 8.39776H5.49733L6.02178 10.2724L6.53893 8.39776H7.25177L6.37446 11.064H5.64058L5.62972 11.03L4.76362 8.39776ZM8.02231 10.3888C8.10463 10.5076 8.23073 10.5651 8.4081 10.5651C8.551 10.5651 8.66641 10.5266 8.75111 10.4504C8.79123 10.4162 8.8233 10.3736 8.84502 10.3255C8.86673 10.2775 8.87755 10.2253 8.8767 10.1726V10.0758H8.37788V9.57463H9.4945V10.131C9.49484 10.2215 9.48343 10.3117 9.46055 10.3993C9.43509 10.4932 9.39499 10.5825 9.34175 10.6639C9.2858 10.7513 9.21591 10.8288 9.13485 10.8935C9.04089 10.9657 8.93437 11.0199 8.82069 11.0533C8.69008 11.093 8.5543 11.1132 8.41777 11.1132H8.4008C8.20935 11.1132 8.03725 11.0821 7.88993 11.021C7.74878 10.965 7.62387 10.8745 7.52655 10.7579C7.43303 10.6425 7.36298 10.5099 7.32033 10.3676C7.27351 10.2101 7.25063 10.0466 7.25244 9.88233V9.56207C7.25244 9.19461 7.35632 8.89743 7.56117 8.6795C7.76603 8.46158 8.05337 8.34888 8.41098 8.34888C8.56796 8.34681 8.72404 8.37297 8.87178 8.4261C8.99896 8.47087 9.11502 8.54247 9.21208 8.63605C9.29695 8.7207 9.36517 8.82053 9.4132 8.93035C9.46113 9.0391 9.48753 9.1561 9.49093 9.27489L9.49246 9.32445H8.86584L8.86075 9.28219C8.84581 9.16016 8.79863 9.06766 8.71648 8.99943C8.63434 8.9312 8.52979 8.8976 8.403 8.8976C8.24669 8.8976 8.12618 8.95106 8.03436 9.0607C7.94254 9.17034 7.89468 9.3416 7.89468 9.56699V9.88199C7.89451 10.0955 7.93762 10.2664 8.02265 10.389L8.02231 10.3888Z"
          fill="#0D0E0F"
        />
        <path
          d="M7.49532 4.67196H4.20964C4.13833 4.67069 4.06747 4.68364 4.00122 4.71006C3.93497 4.73647 3.87464 4.77582 3.82376 4.8258C3.77288 4.87578 3.73247 4.9354 3.70488 5.00117C3.67729 5.06695 3.66309 5.13756 3.66309 5.20888C3.66309 5.28021 3.67729 5.35081 3.70488 5.41659C3.73247 5.48236 3.77288 5.54198 3.82376 5.59196C3.87464 5.64195 3.93497 5.68129 4.00122 5.70771C4.06747 5.73412 4.13833 5.74707 4.20964 5.7458H7.49532C7.56663 5.74707 7.63748 5.73412 7.70374 5.70771C7.76999 5.68129 7.83032 5.64195 7.8812 5.59196C7.93208 5.54198 7.97249 5.48236 8.00008 5.41659C8.02766 5.35081 8.04187 5.28021 8.04187 5.20888C8.04187 5.13756 8.02766 5.06695 8.00008 5.00117C7.97249 4.9354 7.93208 4.87578 7.8812 4.8258C7.83032 4.77582 7.76999 4.73647 7.70374 4.71006C7.63748 4.68364 7.56663 4.67069 7.49532 4.67196Z"
          fill="#0D0E0F"
        />
        <path
          d="M7.49532 2.87508H4.20964C4.13833 2.87382 4.06747 2.88677 4.00122 2.91318C3.93497 2.93959 3.87464 2.97894 3.82376 3.02892C3.77288 3.07891 3.73247 3.13853 3.70488 3.2043C3.67729 3.27007 3.66309 3.34068 3.66309 3.412C3.66309 3.48333 3.67729 3.55394 3.70488 3.61971C3.73247 3.68548 3.77288 3.7451 3.82376 3.79509C3.87464 3.84507 3.93497 3.88442 4.00122 3.91083C4.06747 3.93724 4.13833 3.95019 4.20964 3.94893H7.49532C7.56663 3.95019 7.63748 3.93724 7.70374 3.91083C7.76999 3.88442 7.83032 3.84507 7.8812 3.79509C7.93208 3.7451 7.97249 3.68548 8.00008 3.61971C8.02766 3.55394 8.04187 3.48333 8.04187 3.412C8.04187 3.34068 8.02766 3.27007 8.00008 3.2043C7.97249 3.13853 7.93208 3.07891 7.8812 3.02892C7.83032 2.97894 7.76999 2.93959 7.70374 2.91318C7.63748 2.88677 7.56663 2.87382 7.49532 2.87508Z"
          fill="#0D0E0F"
        />
      </g>
      <defs>
        <clipPath id="clip0_43467_23674">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
    <svg
      v-if="name === 'downloadpng'"
      width="16"
      height="16"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_43467_23692)">
        <path
          d="M12.7337 2.9089L9.93697 0.238802C9.77684 0.0853251 9.56354 -0.000248606 9.34174 5.42526e-07H2.3627C2.13397 0.000225211 1.91467 0.0911897 1.75293 0.25293C1.59119 0.41467 1.50022 0.633972 1.5 0.862706V13.1371C1.50022 13.3659 1.59118 13.5852 1.75292 13.747C1.91465 13.9087 2.13395 13.9997 2.3627 14H12.1388C12.3676 13.9997 12.5869 13.9087 12.7486 13.747C12.9104 13.5852 13.0014 13.3659 13.0017 13.1371V3.53314C13.0013 3.4164 12.9774 3.30093 12.9314 3.19366C12.8853 3.08639 12.8181 2.98953 12.7337 2.9089ZM10.1221 1.90074L11.3027 3.0277H10.1221V1.90074ZM11.9268 12.926H2.57299V11.8262H9.99264C10.1473 11.8262 10.2162 11.7573 10.2162 11.6028V7.85532C10.2162 7.70088 10.1473 7.63197 9.99264 7.63197H2.57299V1.07384H9.04846V3.56471C9.0486 3.70706 9.10519 3.84355 9.20584 3.94422C9.30648 4.04489 9.44295 4.10153 9.5853 4.10171H11.9275L11.9268 12.926ZM2.69248 11.0624V8.39623H3.78855C4.07471 8.39623 4.30366 8.48347 4.46881 8.6554C4.63395 8.82733 4.71677 9.04577 4.71677 9.30765C4.71677 9.57276 4.6331 9.7934 4.46813 9.96295C4.30316 10.1325 4.07352 10.2189 3.78652 10.2189H3.33675V11.0626L2.69248 11.0624ZM4.96508 11.0624V8.39623H5.48528L6.5301 9.96329V8.39623H7.13856V11.0624H6.61989L5.57337 9.48399V11.0624H4.96508ZM8.23973 10.3862C8.32221 10.5051 8.44832 10.5631 8.62568 10.5638C8.76859 10.5638 8.884 10.5251 8.96869 10.4489C9.00884 10.4147 9.04092 10.3721 9.06261 10.324C9.0843 10.276 9.09506 10.2237 9.09412 10.171V10.074H8.59615V9.57259H9.71293V10.1291C9.71311 10.2196 9.7017 10.3098 9.67899 10.3974C9.62458 10.5921 9.51064 10.7649 9.35312 10.8915C9.25911 10.9637 9.15253 11.018 9.03879 11.0514C8.90809 11.091 8.77227 11.1112 8.6357 11.1111H8.61872C8.42727 11.1111 8.25517 11.0801 8.10785 11.019C7.96677 10.9628 7.84193 10.8723 7.74465 10.7557C7.65103 10.6404 7.58097 10.5077 7.53843 10.3654C7.49157 10.2082 7.46869 10.0449 7.47054 9.88098V9.56122C7.47054 9.19376 7.57441 8.89675 7.77927 8.67865C7.98413 8.46056 8.27147 8.34803 8.62907 8.34803C8.78553 8.34596 8.94109 8.372 9.08835 8.42492C9.21554 8.46966 9.3316 8.54126 9.42864 8.63486C9.51372 8.71942 9.58217 8.81919 9.63044 8.929C9.67838 9.03781 9.70484 9.15486 9.70835 9.27371L9.70971 9.32327H9.08173L9.07647 9.281C9.06153 9.1588 9.01435 9.06647 8.9322 8.99824C8.85006 8.93002 8.74669 8.89641 8.61872 8.89539C8.46241 8.89539 8.3419 8.94868 8.25008 9.05833C8.15826 9.16797 8.11057 9.33922 8.11057 9.56427V9.87911C8.11176 10.093 8.15487 10.2637 8.23973 10.3862Z"
          fill="#0D0E0F"
        />
        <path
          d="M7.49398 4.67196H4.20812C4.06738 4.67446 3.93324 4.73213 3.83459 4.83255C3.73594 4.93297 3.68066 5.06811 3.68066 5.20888C3.68066 5.34965 3.73594 5.48479 3.83459 5.58521C3.93324 5.68563 4.06738 5.7433 4.20812 5.7458H7.49398C7.56529 5.74707 7.63614 5.73412 7.70239 5.70771C7.76865 5.68129 7.82897 5.64195 7.87985 5.59196C7.93073 5.54198 7.97114 5.48236 7.99873 5.41659C8.02632 5.35081 8.04053 5.28021 8.04053 5.20888C8.04053 5.13756 8.02632 5.06695 7.99873 5.00117C7.97114 4.9354 7.93073 4.87578 7.87985 4.8258C7.82897 4.77582 7.76865 4.73647 7.70239 4.71006C7.63614 4.68364 7.56529 4.67069 7.49398 4.67196Z"
          fill="#0D0E0F"
        />
        <path
          d="M7.49398 2.87508H4.20812C4.06738 2.87759 3.93324 2.93526 3.83459 3.03567C3.73594 3.13609 3.68066 3.27124 3.68066 3.412C3.68066 3.55277 3.73594 3.68792 3.83459 3.78834C3.93324 3.88876 4.06738 3.94642 4.20812 3.94893H7.49398C7.56529 3.95019 7.63614 3.93724 7.70239 3.91083C7.76865 3.88442 7.82897 3.84507 7.87985 3.79509C7.93073 3.7451 7.97114 3.68548 7.99873 3.61971C8.02632 3.55394 8.04053 3.48333 8.04053 3.412C8.04053 3.34068 8.02632 3.27007 7.99873 3.2043C7.97114 3.13853 7.93073 3.07891 7.87985 3.02892C7.82897 2.97894 7.76865 2.93959 7.70239 2.91318C7.63614 2.88677 7.56529 2.87382 7.49398 2.87508Z"
          fill="#0D0E0F"
        />
        <path
          d="M3.94953 9.60891C4.02879 9.55001 4.06715 9.45021 4.06715 9.3034C4.06715 9.17509 4.0332 9.0758 3.96532 9.00808C3.89743 8.94036 3.80272 8.90625 3.67678 8.90625H3.33496V9.70073H3.57427C3.74077 9.70073 3.86704 9.66967 3.94953 9.60891Z"
          fill="#0D0E0F"
        />
      </g>
      <defs>
        <clipPath id="clip0_43467_23692">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
    <!-- Heco 链图标 -->
    <img
      v-if="name === 'heco'"
      width="18"
      height="18"
      :src="require('@/assets/image/homepage/Heco.svg')"
    />
    <!-- Polygon 链图标 -->
    <img
      v-if="name === 'polygon'"
      width="18"
      height="18"
      :src="require('@/assets/image/homepage/Polygon.svg')"
    />
  </div>
</template>

<script>
export default {
  name: "CanvasIcons",
  props: {
    name: {
      type: String,
      required: true,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    iconColor: {
      type: String,
    },
    iconWidth: {
      type: String,
    },
  },
};
</script>
<style lang="less" scoped>
@import "@/assets/css/newcanvas/surveyadvice.less";
@import "@/assets/css/adjustment/adjustText.less";

.hover-icon {
  color: #0d0e0f;
}

.hover-icon:hover {
  color: #05abfaff;
}
</style>
